import { cn } from "@faire/prototype-playground/lib/utils";
import React from "react";

import { PADX } from "../constants";
import { type PriceMode } from "../PriceLabel";
import { ProductCard, type ProductCardData } from "../ProductCard";

interface BetterTogetherModuleProps {
  title: string;
  /** Explanatory copy framing the cross-brand recommendation. */
  description?: string;
  products: ProductCardData[];
  priceMode: PriceMode;
}

/**
 * "Better Together" — cross-brand complementary recommendations. Surfaces real,
 * non-competing products from OTHER brands ("shops like yours also stocked
 * these") to help a newer retailer round out and grow their opening order. Each
 * tile carries its brand name and stays sign-up gated. Lives near the bottom of
 * the home; the same module could also drop into the All Products tab.
 */
export const BetterTogetherModule: React.FC<BetterTogetherModuleProps> = ({
  title,
  description,
  products,
  priceMode,
}) => {
  if (products.length === 0) return null;
  return (
    <div className={cn("pt-8 pb-12", PADX)}>
      <div className="mb-5 flex flex-col gap-1.5">
        <p className="type-fs-section-heading text-fs-text-primary">{title}</p>
        {description ? (
          <p className="type-fs-paragraph text-fs-text-primary max-w-2xl">
            {description}
          </p>
        ) : null}
      </div>
      <div className="grid grid-cols-2 gap-x-[var(--grid-gutter,16px)] gap-y-6 md:grid-cols-3 lg:grid-cols-6">
        {products.map((card) => (
          <div key={card.token} className="min-w-0">
            <ProductCard
              product={card}
              priceMode={priceMode}
              showBestsellerBadge={false}
            />
          </div>
        ))}
      </div>
    </div>
  );
};
